<div class="full-page-container">
  <fgb-banner [title]="'faq.page.title' | translate"></fgb-banner>

  <fgb-page-header [pageTitle]="'faq.page.title'" [backButtonLink]="'/'" [showBalance]="false" [showQr]="false"></fgb-page-header>

  <div class="container">
    <fgbcl-faq-section></fgbcl-faq-section>
  </div>
</div>
